import React, { FC } from 'react'
import styles from 'styles/components/tag.module.scss'

type Props = {
  isConfigured: boolean
}

const BreadPreorderTag: FC<Props> = (props) => {
  const { isConfigured } = props
  if (isConfigured) {
    return <span className={styles.tag__preorder}>事前予約 : 受付中</span>
  } else {
    return <span className={styles.tag__preorder_none}>事前予約 : 未設定</span>
  }
}

export default BreadPreorderTag
